/* eslint-disable */

import { AvtalsansvarigDTO } from "../../models/AvtalsansvarigDTO";
import { LeverantorsorderradDTO } from "./LeverantorsorderradDTO";

export class LeverantorsorderDetailRequestDTO   {

    public id: number;
    public leverantorId: number;
    public leverantor: string;
    public orderNr: string;
    public avtalsansvarig: AvtalsansvarigDTO;
    public status: string;
    public kontaktinformation: string;
    public leverantorsorderrader: LeverantorsorderradDTO[];
    public rowVersion: number[];
    public changeType: string;

    constructor() {
        this.id = undefined;
        this.leverantorId = undefined;
        this.leverantor = undefined;
        this.orderNr = undefined;
        this.avtalsansvarig = undefined;
        this.status = undefined;
        this.kontaktinformation = undefined;
        this.leverantorsorderrader = undefined;
        this.rowVersion = undefined;
        this.changeType = undefined;
    }
}
